export default {
    CurrentWeek:'Current Week',
    CurrentMonth:'Current Month',
    Completed:'Completed',
    OverallSeason:'Overall Season'
}


// WEBPACK FOOTER //
// ./src/containers/eventsview/constants/messages.js